<kodit-number-input
  [formCtrlId]="formCtrlId"
  [formCtrl]="formCtrl"
  suffix=" dan(a)"
  [ctrlOnlyIntegers]="true"
></kodit-number-input>
